import { watch } from 'vue'

import { useImpactStore } from '../stores/impactStore'
import { useImpactRecommendationStore } from '../stores/recommendationStore'

import { useWorkspace } from '@/features/account'
import { registerSessionReset } from '@/features/auth'

/** Schedules, runs, quota, profiles and the recommendation strip are all workspace-scoped
 *  (`CausalScope` is account + workspace), and both stores bump a generation counter on reset so
 *  an in-flight response for the old scope can never land. Everything clears on both edges. */
export function registerImpactLifecycle(): () => void {
  const impact = useImpactStore()
  const recommendations = useImpactRecommendationStore()
  const { workspaceId } = useWorkspace()
  const resetAll = (): void => {
    impact.reset()
    recommendations.resetState()
  }
  const stopWorkspace = watch(
    workspaceId,
    (next, previous) => {
      if (String(next ?? '') !== String(previous ?? '')) resetAll()
    },
    { flush: 'sync' },
  )
  const unregisterSession = registerSessionReset(resetAll)
  return () => {
    stopWorkspace()
    unregisterSession()
  }
}
